import { render, staticRenderFns } from "./Android.vue?vue&type=template&id=bb2d29b4&"
import script from "./Android.vue?vue&type=script&lang=ts&"
export * from "./Android.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports